import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setShowUpsertIntegrationModalReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showUpsertIntegrationModal = action.payload;
  });
};

export default setShowUpsertIntegrationModalReducer;
